module.exports = __webpack_public_path__ + "media/V96.4164f40a.mp4";